import Swiper from 'swiper';
import { Navigation, Scrollbar, Autoplay, EffectFade } from 'swiper/modules';

(function (once, Drupal) {
  Drupal.behaviors.swiperBehavior = {
    attach: function (context, settings) {
      once('swiperBehavior', 'div.swiper-container', context).forEach(
        function (element) {
          const swiperElement = element.querySelector('.swiper');
          const config = JSON.parse(element.dataset.swiperConfig);
          const swiper = new Swiper(swiperElement, {
            speed: 300,
            modules: [Navigation, Scrollbar, Autoplay, EffectFade],
            scrollbar: {
              el: '.swiper-scrollbar',
              hide: false,
              dragSize: 180,
              draggable: true,
            },
            watchOverflow: true,
            navigation: {
              nextEl: element.querySelector('.swiper-button-next'),
              prevEl: element.querySelector('.swiper-button-prev'),
            },
            ...config,
          });
        }
      );
    },
  };
})(once, Drupal);
